export const checkUseService = (service, data = []) => {
    var useService = false;
    data.map(({status,serviceType})=>{
        if(serviceType == service && status == 'ACTIVE'){
            useService = true;
        }
    })

    return useService;
}